import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import LockedPlayerGameMarker from 'components/molecules/locked-player-game-marker';
import {LineupPlayers as BaseLineupPlayers} from '../lineup-players';
import {round} from 'helpers/number-helper';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import {connect} from 'react-redux';
import DisabledPlayerIfGameInactiveSpecification from 'specifications/disabled-player-if-game-inactive-specification';

class MlbLineupPlayers extends BaseLineupPlayers {
    getTableHead() {
        return (
            <tr>
                <th className="td-pos">Pos</th>
                <th />
                <th>Name</th>
                <th className="td-confirm">Confirmed</th>
                <th className="narrow-th">Order</th>
                <th className="td-team">Team</th>
                <th className="td-salary">Salary</th>
                <th className="td-fpts">Fpts</th>
                <th className="td-pown">pOwn%</th>
            </tr>
        );
    }

    getRowClassName(player) {
        const {sportConfig, games} = this.props;

        return DisabledPlayerIfGameInactiveSpecification.isSatisfiedBy({sportConfig, games, player})
            ? 'inactive-game'
            : '';
    }

    getTableBody() {
        const {lineupPlayers} = this.props;

        return lineupPlayers.map((player) => {
            let confirmedClassName = 'fa-question-circle';
            let confirmedText = 'Unknown';
            if (player.confirmed) {
                confirmedClassName = 'fa-check';
                confirmedText = 'Yes';
            }

            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <LockedPlayerGameMarker player={player} />
                    </td>
                    <td>
                        <strong className={'player-name'}>{player.name}</strong>
                    </td>
                    <td className="td-confirm">
                        <Tooltip
                            iconClassName={`fa ${confirmedClassName}`}
                            subject={`Position Confirmed: ${confirmedText}`}
                        />
                    </td>
                    <td>{player.order ? `#${player.order}` : ''}</td>
                    <td className="td-team">
                        <TeamLogo teamName={player.team} />
                    </td>
                    <td>{player.salary}</td>
                    <td>{round(player.lineupPoints, Const.POINTS_DECIMAL_PRECISION)}</td>
                    <td>{player.projOwn.getValue()}%</td>
                </tr>
            );
        });
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
    } = state;

    return {
        sportConfig,
        games,
    };
}

const LineupPlayers = connect(mapStatesToProps)(MlbLineupPlayers);

export {LineupPlayers};
